import { DEFAULT_DIGITAL_ORDER } from '@/shared/api/digitalOrder';
import { type SchemaDigitalOrder } from '@/shared/api/openApi';

interface GetDigitalCheckoutFormContextParams {
    orderId: string;
    signature: string;
    storeSlug: string;
    companyShopUrl: string;
    order?: SchemaDigitalOrder | null;
    refetch: () => Promise<unknown>;
}

export const getDigitalCheckoutFormContext = ({
    orderId,
    signature,
    storeSlug,
    companyShopUrl,
    order,
    refetch,
}: GetDigitalCheckoutFormContextParams) => {
    return {
        orderId,
        signature,
        storeSlug,
        storeUrl: companyShopUrl,
        order: order || DEFAULT_DIGITAL_ORDER,
        refetch,
    };
};
